import { request } from "../../../app/api-client/ApiClient";

/**
 * Obtiene el ultimo preinforme (pagina de un solo elemento) de un usuario
 * a partir de su numero de documento.
 * @param {Function} dispatch
 * @param {String|Number} documento
 */
export function getPreinformeByDocumento(dispatch, documento) {
	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/preinforme/documento/${documento}?page=0&size=1`,
		method: "GET",
	}, dispatch);
}

/**
 * Obtiene los metadatos del informe (incluida la url publica del PDF en S3)
 * a partir de su numero de informe.
 * @param {Function} dispatch
 * @param {String} numeroInforme
 */
export function getInformeByNumero(dispatch, numeroInforme) {
	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/informe/${numeroInforme}`,
		method: "GET",
	}, dispatch);
}
